import axios from "axios";
import { useMutation } from "react-query";

/** End every session for the signed-in account, on every device. */
export const logoutEverywhere = () =>
  axios.post("/api/auth/logout-all").then(() => undefined);

export const useLogoutEverywhere = () => useMutation(logoutEverywhere);

export type PartnerPasswordResetRequest = { email: string };

/** Email a partner user a reset link. Answers the same for unknown emails. */
export const requestPartnerPasswordReset = ({
  email,
}: PartnerPasswordResetRequest) =>
  axios
    .post("/api/auth/forgot-password", { email, type: "partner" })
    .then(() => undefined);

export const useRequestPartnerPasswordReset = () =>
  useMutation(requestPartnerPasswordReset);

export type PartnerPasswordReset = { token: string; password: string };

/** Set a partner user's new password from an emailed reset token. */
export const resetPartnerPassword = ({ token, password }: PartnerPasswordReset) =>
  axios
    .post("/api/auth/reset-password", { token, password, type: "partner" })
    .then(() => undefined);

export const useResetPartnerPassword = () => useMutation(resetPartnerPassword);
